import AdditionalMenu from './additional-menu';
import ScreenLock from '../../constants/lock-screen';
import PageOverlay from '../page/page-overlay';
class PrimaryMenu {
    constructor() {
        Object.defineProperty(this, "header", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "topBar", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "menuTrigger", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "menuWrapper", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "mainLink", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "visible", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.header = document.querySelector('#main-header');
        this.topBar = this.header?.querySelector('.top-bar') ?? null;
        this.menuTrigger = this.header?.querySelector('.primary-menu-trigger') ?? null;
        this.menuWrapper = this.header?.querySelector('.primary-menu') ?? null;
        this.mainLink = this.menuWrapper?.querySelectorAll('.main-link') ?? [];
        this.visible = false;
    }
    init() {
        this.menuTrigger?.addEventListener('click', this.toggleMenu.bind(this));
        for (const element of this.mainLink) {
            element.addEventListener('click', (event) => event.preventDefault());
        }
    }
    setMenuHeight() {
        if (this.visible && this.menuWrapper) {
            const topBarClientHeight = this.topBar ? this.topBar.clientHeight : 0;
            this.menuWrapper.style.height = `${window.innerHeight - topBarClientHeight}px`;
        }
    }
    toggleMenu() {
        if (this.menuWrapper?.classList.contains('active')) {
            this.closeMenu();
        }
        else {
            this.openMenu();
        }
    }
    openMenu() {
        this.visible = true;
        AdditionalMenu.closeMenu();
        ScreenLock.lock();
        PageOverlay.open();
        this.setMenuHeight();
        this.menuWrapper?.classList.add('active');
        this.menuTrigger?.classList.add('active');
    }
    closeMenu() {
        this.visible = false;
        this.menuWrapper?.classList.remove('active');
        this.menuTrigger?.classList.remove('active');
        PageOverlay.close();
        ScreenLock.unlock();
    }
}
export default new PrimaryMenu();
